<template>
  <p v-if="showEstimatedDeliveryDate" class="delivery-estimate">
    Order now to receive
    <strong>{{ estimatedDeliveryDateMin }}</strong> -
    <strong>{{ estimatedDeliveryDateMax }}</strong>
  </p>
</template>

<script>
import format from "date-fns/format";
import { mapState, mapActions } from "vuex";

export default {
  name: "DeliveryEstimatorNoInput",
  props: {
    weight: {
      type: Number,
      default: 0.2,
    },
  },
  data() {
    return {
      estimatedDeliveryDateMin: null,
      estimatedDeliveryDateMax: null,
      deliveryService: null,
    };
  },
  computed: {
    ...mapState("app", ["deliveryEstimate"]),
    showEstimatedDeliveryDate() {
      return this.estimatedDeliveryDateMin && this.estimatedDeliveryDateMax;
    },
  },
  mounted() {
    this.getEstimatedDeliveryDate();
  },
  methods: {
    ...mapActions("app", ["setUserPreferences", "getDeliveryEstimate"]),
    async getEstimatedDeliveryDate() {
      await this.getDeliveryEstimate({
        weight: this.weight,
        estimatePostcode: true,
      });

      const {
        estimated_delivery_date_min,
        estimated_delivery_date_max,
        service_type_name,
      } = this.deliveryEstimate;

      this.estimatedDeliveryDateMin = format(
        new Date(estimated_delivery_date_min),
        "E do MMM"
      );

      this.estimatedDeliveryDateMax = format(
        new Date(estimated_delivery_date_max),
        "E do MMM"
      );

      this.deliveryService = service_type_name;
    },
  },
};
</script>

<style lang="scss" scoped>
.delivery-estimate {
  font-size: 11px;
  text-align: center;
  padding: 10px;
}
</style>
